import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ucfirst',
    standalone: false
})
export class UcfirstPipe implements PipeTransform {

  transform(value: string): unknown {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

}
